// extracted by mini-css-extract-plugin
module.exports = {"status-success":"Tasks_status-success__1gspR","status-failed":"Tasks_status-failed__2089_","icon":"Tasks_icon__9eNj0","width":"Tasks_width__PNIgH","date":"Tasks_date__1MEkG"};